import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
};

export type AddEventInput = {
  count: Scalars['Int'];
  crossingId?: InputMaybe<Scalars['Int']>;
  plotCode?: InputMaybe<Scalars['String']>;
  plotId?: InputMaybe<Scalars['Int']>;
  reservationId?: InputMaybe<Scalars['Int']>;
  type: EventType;
};

export type AddEventResponse = {
  __typename?: 'AddEventResponse';
  event?: Maybe<Event>;
  status: MutationStatus;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type Crossing = {
  __typename?: 'Crossing';
  activeReservationCount: Scalars['Int'];
  code: Scalars['String'];
  count: Scalars['Int'];
  failed: Scalars['Float'];
  father?: Maybe<Plot>;
  hasActiveReservation: Scalars['Boolean'];
  id: Scalars['Int'];
  mother?: Maybe<Plot>;
  priority: Scalars['Int'];
  program: Scalars['String'];
  reservations: Array<Reservation>;
  reserved: Scalars['Int'];
  result: Scalars['Float'];
  seedsCounted: Scalars['Int'];
  seedsCountedToday: Scalars['Int'];
  seedsOrdered: Scalars['Int'];
  site: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
};

export type DeleteProgramInput = {
  id: Scalars['Int'];
};

export type DeleteProgramResponse = {
  __typename?: 'DeleteProgramResponse';
  status: MutationStatus;
};

export type Event = {
  __typename?: 'Event';
  count: Scalars['Int'];
  crossing?: Maybe<Crossing>;
  crossingId?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  delta: Scalars['Int'];
  id: Scalars['Int'];
  plot?: Maybe<Plot>;
  plotId?: Maybe<Scalars['Int']>;
  siteId?: Maybe<Scalars['Int']>;
  type: EventType;
  user?: Maybe<Scalars['String']>;
};

export type EventTotal = {
  __typename?: 'EventTotal';
  total: Scalars['Int'];
  type: EventType;
};

export enum EventType {
  Collect25 = 'COLLECT25',
  Collect50 = 'COLLECT50',
  Collect75 = 'COLLECT75',
  Collect100 = 'COLLECT100',
  CorrectSeeds = 'CORRECT_SEEDS',
  CountSeeds = 'COUNT_SEEDS',
  Crossing = 'CROSSING',
  EditCount = 'EDIT_COUNT',
  EditData = 'EDIT_DATA',
  EditPosition = 'EDIT_POSITION',
  EditPriority = 'EDIT_PRIORITY',
  EditProgram = 'EDIT_PROGRAM',
  EditSeedsOrder = 'EDIT_SEEDS_ORDER',
  EditSpares = 'EDIT_SPARES',
  Emasculate = 'EMASCULATE',
  EpIn = 'EP_IN',
  EpOut = 'EP_OUT',
  EpReturn = 'EP_RETURN',
  Fail = 'FAIL',
  Import = 'IMPORT',
  Lost25 = 'LOST25',
  None = 'NONE',
  Remove = 'REMOVE',
  Reserve = 'RESERVE',
  Selfing = 'SELFING',
  Unremove = 'UNREMOVE',
  Unreserve = 'UNRESERVE'
}

export type Export = {
  __typename?: 'Export';
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  rows: Array<ExportRow>;
};

export type ExportRow = {
  __typename?: 'ExportRow';
  breedingOperation?: Maybe<Scalars['String']>;
  breedingOperationType?: Maybe<Scalars['String']>;
  count: Scalars['Float'];
  date: Scalars['DateTime'];
  plot: Scalars['String'];
};

export type FindEventsInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  plot?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type GenerateExportPayload = {
  __typename?: 'GenerateExportPayload';
  export?: Maybe<Export>;
  status: MutationStatus;
};

export type GetRolePayload = {
  __typename?: 'GetRolePayload';
  role: UserRole;
};

export type ImportSourceDataResult = {
  __typename?: 'ImportSourceDataResult';
  error?: Maybe<Scalars['String']>;
  fieldsChanged: Scalars['Int'];
  rowsAdded: Scalars['Int'];
};

export type ImportSourceDataRowInput = {
  breedingOperation: Scalars['String'];
  breedingOperationType: Scalars['String'];
  code: Scalars['String'];
  count: Scalars['Int'];
  fatherPlot?: InputMaybe<Scalars['String']>;
  fatherPosition?: InputMaybe<Scalars['String']>;
  fatherRemoved?: InputMaybe<Scalars['DateTime']>;
  fatherSpares?: Scalars['Int'];
  generation?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  motherPlot: Scalars['String'];
  motherPosition: Scalars['String'];
  motherRemoved?: InputMaybe<Scalars['DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  priority: Scalars['Int'];
  program: Scalars['String'];
  seeds: Scalars['Int'];
  site: Scalars['String'];
  stage?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addEvent: AddEventResponse;
  deleteProgram: DeleteProgramResponse;
  generateExport: GenerateExportPayload;
  importSourceData: ImportSourceDataResult;
  updateEvent: AddEventResponse;
  updateProgram: UpdateProgramResponse;
  updateSite: UpdateSiteResponse;
  updateUser: UpdateUserPayload;
};


export type MutationAddEventArgs = {
  input: AddEventInput;
};


export type MutationDeleteProgramArgs = {
  input: DeleteProgramInput;
};


export type MutationImportSourceDataArgs = {
  input: Array<ImportSourceDataRowInput>;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateProgramArgs = {
  input: UpdateProgramInput;
};


export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export enum MutationStatus {
  Locked = 'LOCKED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type Plot = {
  __typename?: 'Plot';
  available: Scalars['Int'];
  code: Scalars['String'];
  counts: PlotCounts;
  crossingsFather: Array<Crossing>;
  crossingsMother: Array<Crossing>;
  dates: PlotDates;
  eventTotals: Array<EventTotal>;
  id: Scalars['Int'];
  position?: Maybe<Position>;
  program?: Maybe<Scalars['String']>;
  reserved: Scalars['Int'];
  site?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  spareCount: Scalars['Int'];
  type: PlotType;
  year: Scalars['Int'];
};

export type PlotCounts = {
  __typename?: 'PlotCounts';
  available: Scalars['Int'];
  reserved: Scalars['Int'];
  toCollect: Scalars['Int'];
  toEmasculate: Scalars['Int'];
  toSelf?: Maybe<Scalars['Int']>;
};

export type PlotDates = {
  __typename?: 'PlotDates';
  done?: Maybe<Scalars['DateTime']>;
  onHold?: Maybe<Scalars['DateTime']>;
  removed?: Maybe<Scalars['DateTime']>;
};

export enum PlotFilter {
  None = 'NONE',
  Priority = 'PRIORITY',
  Reserved = 'RESERVED'
}

export enum PlotType {
  Father = 'FATHER',
  Mother = 'MOTHER',
  None = 'NONE'
}

export type Position = {
  __typename?: 'Position';
  id: Scalars['Int'];
  locationNumber: Scalars['Int'];
  plots: Array<Plot>;
  table: Scalars['Int'];
};

export type Program = {
  __typename?: 'Program';
  activeEmasculationPriorities: Array<Scalars['Int']>;
  code: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  priorities: Array<Scalars['Int']>;
  year: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  crossing: Crossing;
  crossings: Array<Crossing>;
  events: Array<Event>;
  export: Export;
  exports: Array<Export>;
  findEvents: Array<Event>;
  plot: Plot;
  plotByCode: Plot;
  plots: Array<Plot>;
  position: Position;
  positions: Array<Room>;
  programs: Array<Program>;
  role: GetRolePayload;
  sites: Array<Site>;
  /** @deprecated Use GetSites */
  totals: Total;
  users: Array<User>;
};


export type QueryCrossingArgs = {
  crossingCode: Scalars['String'];
};


export type QueryEventsArgs = {
  crossingId?: InputMaybe<Scalars['Int']>;
  plotId?: InputMaybe<Scalars['Int']>;
};


export type QueryExportArgs = {
  id: Scalars['Int'];
};


export type QueryFindEventsArgs = {
  input: FindEventsInput;
};


export type QueryPlotArgs = {
  plotId: Scalars['Int'];
};


export type QueryPlotByCodeArgs = {
  plotCode: Scalars['String'];
  type: PlotType;
};


export type QueryPlotsArgs = {
  filter?: PlotFilter;
  includeRemoved?: Scalars['Boolean'];
  positionId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  type?: PlotType;
};


export type QueryPositionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPositionsArgs = {
  siteId?: InputMaybe<Scalars['Int']>;
  type: PlotType;
};


export type QueryTotalsArgs = {
  siteId?: InputMaybe<Scalars['Int']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  count: Scalars['Int'];
  crossingId: Scalars['Int'];
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type Room = {
  __typename?: 'Room';
  locationNumber: Scalars['Int'];
  positions: Array<Position>;
};

export type Site = {
  __typename?: 'Site';
  activeDates: Array<Scalars['DateTime']>;
  emasculatedToday: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  eventUpdated: Event;
  eventUpdatedByCrossing: Event;
  eventUpdatedByPlot: Event;
};


export type SubscriptionEventUpdatedByCrossingArgs = {
  crossingId: Scalars['Int'];
};


export type SubscriptionEventUpdatedByPlotArgs = {
  plotId: Scalars['Int'];
};

export type Total = {
  __typename?: 'Total';
  emasculated: Scalars['Int'];
  id: Scalars['Int'];
};

export type UpdateEventInput = {
  count?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
};

export type UpdateProgramInput = {
  activeEmasculationPriorities: Array<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
};

export type UpdateProgramResponse = {
  __typename?: 'UpdateProgramResponse';
  program: Program;
  status: MutationStatus;
};

export type UpdateSiteInput = {
  activeDates?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  id: Scalars['Int'];
};

export type UpdateSiteResponse = {
  __typename?: 'UpdateSiteResponse';
  site: Site;
  status: MutationStatus;
};

export type UpdateUserInput = {
  role: UserRole;
  userId: Scalars['Int'];
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  status: MutationStatus;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  role: UserRole;
};

export enum UserRole {
  Admin = 'ADMIN',
  Normal = 'NORMAL'
}

export type EventFragment = { __typename?: 'Event', id: number, type: EventType, count: number, user?: string | null, date: any, plotId?: number | null, crossingId?: number | null, delta: number, siteId?: number | null };

export type PlotInfoFragment = { __typename?: 'Plot', id: number, code: string, siteId?: number | null, counts: { __typename?: 'PlotCounts', toCollect: number, toSelf?: number | null, available: number, toEmasculate: number, reserved: number }, crossingsMother: Array<{ __typename?: 'Crossing', activeReservationCount: number, hasActiveReservation: boolean, result: number, count: number, father?: { __typename?: 'Plot', id: number, available: number, code: string } | null }> };

export type PositionFragment = { __typename?: 'Position', id: number, locationNumber: number, table: number };

export type RoomInfoFragment = { __typename?: 'Room', locationNumber: number, positions: Array<{ __typename?: 'Position', id: number, locationNumber: number, table: number }> };

export type SiteFragment = { __typename?: 'Site', id: number, name: string, activeDates: Array<any>, emasculatedToday: number };

export type AddEventMutationVariables = Exact<{
  plotId?: InputMaybe<Scalars['Int']>;
  plotCode?: InputMaybe<Scalars['String']>;
  type: EventType;
  count: Scalars['Int'];
  crossingId?: InputMaybe<Scalars['Int']>;
}>;


export type AddEventMutation = { __typename?: 'Mutation', addEvent: { __typename?: 'AddEventResponse', status: MutationStatus, event?: { __typename?: 'Event', id: number, type: EventType, count: number, user?: string | null, date: any, plotId?: number | null, crossingId?: number | null, delta: number, siteId?: number | null } | null } };

export type UpdateEventMutationVariables = Exact<{
  eventId: Scalars['Int'];
  count: Scalars['Int'];
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'AddEventResponse', status: MutationStatus, event?: { __typename?: 'Event', id: number, type: EventType, count: number, user?: string | null, date: any, plotId?: number | null, crossingId?: number | null, delta: number, siteId?: number | null } | null } };

export type GetCrossingQueryVariables = Exact<{
  crossingCode: Scalars['String'];
}>;


export type GetCrossingQuery = { __typename?: 'Query', crossing: { __typename?: 'Crossing', id: number, code: string, count: number, result: number, failed: number, mother?: { __typename?: 'Plot', code: string } | null, father?: { __typename?: 'Plot', code: string } | null } };

export type GetPlotQueryVariables = Exact<{
  plotId: Scalars['Int'];
}>;


export type GetPlotQuery = { __typename?: 'Query', plot: { __typename?: 'Plot', id: number, code: string, available: number, crossingsMother: Array<{ __typename?: 'Crossing', id: number, code: string, reserved: number, activeReservationCount: number, hasActiveReservation: boolean, father?: { __typename?: 'Plot', id: number, code: string, year: number } | null }> } };

export type GetPlotsQueryVariables = Exact<{
  positionId: Scalars['Int'];
  filter?: InputMaybe<PlotFilter>;
  type: PlotType;
}>;


export type GetPlotsQuery = { __typename?: 'Query', plots: Array<{ __typename?: 'Plot', id: number, code: string, siteId?: number | null, counts: { __typename?: 'PlotCounts', toCollect: number, toSelf?: number | null, available: number, toEmasculate: number, reserved: number }, crossingsMother: Array<{ __typename?: 'Crossing', activeReservationCount: number, hasActiveReservation: boolean, result: number, count: number, father?: { __typename?: 'Plot', id: number, available: number, code: string } | null }> }> };

export type GetPositionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPositionQuery = { __typename?: 'Query', position: { __typename?: 'Position', id: number, locationNumber: number, table: number } };

export type GetPositionsQueryVariables = Exact<{
  type: PlotType;
  siteId?: InputMaybe<Scalars['Int']>;
}>;


export type GetPositionsQuery = { __typename?: 'Query', positions: Array<{ __typename?: 'Room', locationNumber: number, positions: Array<{ __typename?: 'Position', id: number, locationNumber: number, table: number }> }> };

export type GetRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleQuery = { __typename?: 'Query', role: { __typename?: 'GetRolePayload', role: UserRole } };

export type GetSeedCrossingQueryVariables = Exact<{
  crossingCode: Scalars['String'];
}>;


export type GetSeedCrossingQuery = { __typename?: 'Query', crossing: { __typename?: 'Crossing', id: number, code: string, count: number, result: number, failed: number, seedsCounted: number, seedsOrdered: number, seedsCountedToday: number, mother?: { __typename?: 'Plot', code: string } | null, father?: { __typename?: 'Plot', code: string } | null } };

export type GetSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', id: number, name: string, activeDates: Array<any>, emasculatedToday: number }> };

export type EventUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EventUpdatedSubscription = { __typename?: 'Subscription', eventUpdated: { __typename?: 'Event', id: number, type: EventType, count: number, user?: string | null, date: any, plotId?: number | null, crossingId?: number | null, delta: number, siteId?: number | null } };

export const EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"plotId"}},{"kind":"Field","name":{"kind":"Name","value":"crossingId"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}}]}}]} as unknown as DocumentNode<EventFragment, unknown>;
export const PlotInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlotInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toCollect"}},{"kind":"Field","name":{"kind":"Name","value":"toSelf"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"toEmasculate"}},{"kind":"Field","name":{"kind":"Name","value":"reserved"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crossingsMother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"father"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeReservationCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveReservation"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}}]}}]} as unknown as DocumentNode<PlotInfoFragment, unknown>;
export const PositionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Position"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"table"}}]}}]} as unknown as DocumentNode<PositionFragment, unknown>;
export const RoomInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Room"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Position"}}]}}]}},...PositionFragmentDoc.definitions]} as unknown as DocumentNode<RoomInfoFragment, unknown>;
export const SiteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Site"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeDates"}},{"kind":"Field","name":{"kind":"Name","value":"emasculatedToday"}}]}}]} as unknown as DocumentNode<SiteFragment, unknown>;
export const AddEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plotId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plotCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crossingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plotId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plotCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plotCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"crossingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crossingId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Event"}}]}}]}}]}},...EventFragmentDoc.definitions]} as unknown as DocumentNode<AddEventMutation, AddEventMutationVariables>;
export const UpdateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Event"}}]}}]}}]}},...EventFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const GetCrossingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCrossing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crossingCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"crossingCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crossingCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"father"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetCrossingQuery, GetCrossingQueryVariables>;
export const GetPlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"plotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"crossingsMother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"father"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reserved"}},{"kind":"Field","name":{"kind":"Name","value":"activeReservationCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveReservation"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlotQuery, GetPlotQueryVariables>;
export const GetPlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PlotFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlotType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"positionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlotInfo"}}]}}]}},...PlotInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetPlotsQuery, GetPlotsQueryVariables>;
export const GetPositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPosition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Position"}}]}}]}},...PositionFragmentDoc.definitions]} as unknown as DocumentNode<GetPositionQuery, GetPositionQueryVariables>;
export const GetPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlotType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomInfo"}}]}}]}},...RoomInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetPositionsQuery, GetPositionsQueryVariables>;
export const GetRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<GetRoleQuery, GetRoleQueryVariables>;
export const GetSeedCrossingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSeedCrossing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crossingCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"crossingCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crossingCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"father"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seedsCounted"}},{"kind":"Field","name":{"kind":"Name","value":"seedsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"seedsCountedToday"}}]}}]}}]} as unknown as DocumentNode<GetSeedCrossingQuery, GetSeedCrossingQueryVariables>;
export const GetSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Site"}}]}}]}},...SiteFragmentDoc.definitions]} as unknown as DocumentNode<GetSitesQuery, GetSitesQueryVariables>;
export const EventUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"eventUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Event"}}]}}]}},...EventFragmentDoc.definitions]} as unknown as DocumentNode<EventUpdatedSubscription, EventUpdatedSubscriptionVariables>;